import React from "react";
import ReactGA from 'react-ga4';
import {Link} from 'react-router-dom';
// import FooterLinks from './footer-links/footer-links.js'
import HelpAndCurrency from './help-and-currency.js';
import AboutLinks from './footer-links/about-links.js';
import * as Utilities from './utilities.js';



export default class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      email: null,
	  captcha: null,
	  code: null,
	  pageReturn: null,
	  button_state: true,
    };
	this.handleInputChange = this.handleInputChange.bind(this);

  }
  componentDidMount() {
	var ga = Utilities.gaInitialize(ReactGA);
	Utilities.gaPageView(ga, "msa_page_view", "/forgot", "Forgot Pwd");
	var url = Utilities.getApiURL('captcha.php', '');
    fetch(url, {method: 'GET', credentials: 'include'})
    .then(results => {
      return results.json();
    }).then((data) => {
		this.setCaptcha(data);
    })
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }
  forgot(){
  	var url = Utilities.getApiURL('account.php', '?do=forgot');
    fetch(url, {
			method: 'POST',
			credentials: 'include',
			headers: {"Content-Type": "application/x-www-form-urlencoded"},
			body: "&email="+this.state.email
		})
    .then(results => {
      return results.json();
    }).then((data) => {
        this.alertUser(data);
    })
  }
  alertUser(data){
	  if(data.forgot_password){
		  alert(data.forgot_password.message);
  		  window.location = '/'
  	  } else {
		  alert("Error: "+data.error.message);
	      this.setState({button_state: true});  //activate button so user can retry
	  }
  }
  captcha(){
      if(this.state.button_state === false)
		  return false; // button is disabled.
	  else {
		  this.setState({button_state: false}); //disable button
      	  var url = Utilities.getApiURL('captcha.php', '?do=check&code='+this.state.code);
	      var body = "&code="+this.state.code;
          fetch(url, {
			    method: 'POST',
			    credentials: 'include',
			    headers: {"Content-Type": "application/x-www-form-urlencoded"},
			    body: body
		    })
          .then(results => {
          return results.json();
          }).then((data) => {
            this.captchaResult(data);
          })
       }
  }
  setCaptcha(data) {
	let captcha = data.captcha.clue.map((c) => {
		return (<img src={c}/>)
	});
	this.setState({captcha: captcha});
	this.setState({button_state: true}); //activate button
  }
  captchaResult(data){
	  if(data.captcha.status === true && this.state.button_state === false){
		  this.forgot()
		  //alert("send email"); 
	  } else {
		  alert("Error: Verification code did not match.  Please check the code and try again.")
		  this.setCaptcha(data);
		  this.setState({button_state: true}); // activate button
	  }
  }
  render(){

    return(
      <div>

        <div className = 'content-area-container'>
          <div className="header-text">
            <div className="returning-customer">
              <div className="returning-customer-header">
                <h1>Forgot Password</h1>
              </div>
                  <div className="reset-form-row">
                    <div className="form-group col-md-12">
                      <label className="inputEmail"><strong>* Email Address</strong></label>
                      <input type="text" className="form-control" name='email' placeholder="Email Address" onChange={this.handleInputChange}/>
                    </div>
					<div className="form-group col-md-12">
						<div>{this.state.captcha}</div>
					</div>
                    <div className="form-group col-md-12">
                      <label className="inputCaptcha"><strong>* Code</strong></label>
                      <input type="text" className="form-control" name='code' placeholder="Code" onChange={this.handleInputChange}/>
                    </div>
                  </div>

				  <div className="reset-password-button">
                  	<button type="submit" className="btn btn-primary btn-sm" onClick={(e) => this.captcha()}><h4>Reset Password</h4></button>
				  </div>



            </div>
          </div>

					<div className="company-logo">
            <img src="https://www.msaironline.com/images/msair.png" alt="logo"></img>
          </div>



          <div className="FooterLinks1">
            <HelpAndCurrency />

          </div>
          <div className="FooterLinks2">
            <AboutLinks />
          </div>
              </div>
              <div className="about-footer">
                <div className="terms">
                  <p><a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Use</a> | <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></p>
                </div>
                <div className="copyright">
                  <p>&copy; {new Date().getFullYear()} - MS Air, Inc. | <Link to="/">Home</Link></p>
              </div>
              </div>

      </div>


    )
  }
}
